module.exports = __webpack_public_path__ + "img/greenly@2x.c1c839ff.webp";